module.exports = __webpack_public_path__ + "img/20180815_151538_154.8db91f4a.jpg";